import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ESIMOrderSuccessModal from '../../../copms/Modal/ESIMOrderSuccessModal';
import { esimApi } from './esimApi';
import { request } from '../../../config';
import currencyFilter from '../../../helpers/currencyFilter';
import lastOperationIcon from '../img/last-operations-icon.png';

let custObject = JSON.parse(localStorage.getItem('custObject'));

class ESIMOrder extends Component {
    state = {
        selectedCountry: {
            name: '',
            flag: ''
        },
        selectedPlan: {
            volume: '',
            period: '',
            price: '',
            currency: ''
        },
        orderEmail: (custObject?.customer !== undefined) ? custObject.customer?.email : custObject?.email,
        orderPaymentMethod: '',
        promoCode: '',
        promoStatus: null,
        promoLoading: false,
        quote: null,
        quoteLoading: false,
        quoteError: null,
        // paymentMethods: ['Kart hesabı', 'Debit kart', 'Kredit kart'],
        showSuccessModal: false,
        isSubmitting: false,
        orderRef: null,
        esimId: null,
        cards: [],
        dropdownVisibility: false,
        selectedCard: 0,
        selectedValue: -1,
        selectedIndex: -1,
        step: 1,
    }

    componentDidMount = () => {
        this.loadInitialData();
    }

    loadInitialData = async () => {
        await Promise.all([
            this.loadPlanDetails(),
            this.loadCards()
        ]);
    }

    loadCards = async () => {
        const customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        const getCategoryListCustomerRequestBody = customerType === 'Juridical' ? {
            custId: localStorage.getItem('custId'),
            compId: localStorage.getItem('compId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        } : {
            custId: localStorage.getItem('custId'),
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase()
        };

        try {
            const response = await fetch(request(`card/getCardListFor${customerType}Customer`, getCategoryListCustomerRequestBody));
            const getCardListForCustomerResponseJSON = await response.text();
            const JSON = require('true-json-bigint');
            const getCardListForCustomerResponse = JSON.parse(getCardListForCustomerResponseJSON);

            if (getCardListForCustomerResponse.status.statusCode !== 1 && getCardListForCustomerResponse.status.statusCode !== 137) {
                if (getCardListForCustomerResponse.status.statusCode === 200) {
                    this.props.logout();
                    return;
                }

                this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getCardListForCustomerResponse.status.statusCode));
                return;
            }

            if (getCardListForCustomerResponse.status.statusCode === 137) {
                getCardListForCustomerResponse.cardList = [];
            }

            const cardList = [...getCardListForCustomerResponse.cardList];

            this.setState({
                cards: cardList,
            });
        } catch (error) {
            this.props.history.push('/technical-break');
        }
    }

    // hydrateStateFromRoute = () => {
    //     const routeState = this.props.location?.state || {};
    //     const routeCountry = routeState.selectedCountry;
    //     const routePlan = routeState.selectedPlan;

    //     const normalizedCountry = typeof routeCountry === 'string'
    //         ? { name: routeCountry, flag: '🌍' }
    //         : routeCountry;

    //     this.setState((prevState) => ({
    //         selectedCountry: normalizedCountry || prevState.selectedCountry,
    //         selectedPlan: routePlan || prevState.selectedPlan
    //     }));
    // }

    changeDropdownVisibility = (event) => {
        event.preventDefault();
        if (this.state.step >= 2) {
            this.setState({ dropdownVisibility: false });
        } else {
            this.setState({ dropdownVisibility: !this.state.dropdownVisibility });
        }
    }

    onSelect = (event, val, checkNewCard) => {
        event.preventDefault();
        this.setState({ dropdownVisibility: false, selectedValue: val, fromAnotherCard: checkNewCard ?? false }, this.calculateQuote);
    }

    loadPlanDetails = async () => {
        const planId = this.props.match?.params?.planId;

        if (!planId) {
            return;
        }

        try {
            const response = await esimApi.getPlan(planId);
            const planData = response?.data;

            if (!planData) {
                return;
            }

            this.setState((prevState) => ({
                selectedCountry: {
                    name: planData.destinationName || prevState.selectedCountry.name,
                    flag: prevState.selectedCountry.flag || '🌍'
                },
                selectedPlan: {
                    ...prevState.selectedPlan,
                    id: planData.planId || planId,
                    volume: planData.dataLabel || planData.title || prevState.selectedPlan.volume,
                    period: planData.validityDays ? `${planData.validityDays} days` : prevState.selectedPlan.period,
                    price: this.formatPriceFromCents(planData.priceCents, planData.currency),
                    currency: String(planData.currency || prevState.selectedPlan.currency || 'AZN').toUpperCase()
                }
            }));
        } catch (error) {
            // Keep existing state if plan details request fails.
        }
    }

    handleBack = () => {
        this.props.history.goBack();
    }

    updateField = (field, value) => {
        this.setState({ [field]: value });
    }

    handlePromoCodeChange = (event) => {
        const promoCode = event.target.value;

        this.setState({
            promoCode,
            promoStatus: null,
            quote: null,
            quoteError: null,
            selectedPlan: { ...this.state.selectedPlan, newPrice: null }
        }, () => {
            if (!promoCode.trim()) {
                this.calculateQuote('');
            }
        });
    }

    // getPlanId = () => {
    //     const planIdFromState = this.state.selectedPlan?.id;
    //     const planIdFromRoute = this.props.match?.params?.planId;
    //     const rawPlanId = planIdFromState || planIdFromRoute;
    //     const numericPlanId = Number(rawPlanId);

    //     return Number.isFinite(numericPlanId) && numericPlanId > 0 ? numericPlanId : null;
    // }

    getExpectedPriceCents = () => {
        const rawPrice = String(this.state.selectedPlan?.price || '')
            .replace(/AZN|\$/gi, '')
            .trim();
        const normalizedPrice = rawPrice.replace(/,/g, '.').replace(/[^0-9.]/g, '');
        const parsed = Number(normalizedPrice);

        if (!Number.isFinite(parsed) || parsed <= 0) {
            return null;
        }

        return Math.round(parsed * 100);
    }

    formatPriceFromCents = (cents) => {
        const value = Number(cents);

        if (!Number.isFinite(value) || value <= 0) {
            return '';
        }

        return `$${(value / 100).toFixed(2)}`;
    }

    formatQuoteAmount = (amount, currency) => {
        const value = Number(amount);

        if (!Number.isFinite(value)) {
            return '';
        }

        return `${value.toFixed(2)} ${String(currency || '').toUpperCase()}`.trim();
    }

    calculateQuote = async (promoCode = this.state.promoCode) => {
        const planId = this.props.match?.params?.planId;
        const cardId = Number(this.state.cards[this.state.selectedValue]?.cardId);

        if (!planId || !Number.isFinite(cardId) || cardId <= 0) {
            this.setState({ quote: null, quoteError: null });
            return null;
        }

        this.setState({ quoteLoading: true, quoteError: null });

        try {
            const response = await esimApi.getOrderQuote({
                planId,
                cardId,
                ...(promoCode?.trim() ? { promoCode: promoCode.trim() } : {})
            });
            const statusCode = Number(response?.status?.statusCode);

            if (statusCode !== 1 || !response?.data) {
                this.setState({
                    quote: null,
                    quoteLoading: false,
                    quoteError: response?.status?.statusMessage || this.props.t('unexpected error')
                });
                return null;
            }

            this.setState({ quote: response.data, quoteLoading: false, quoteError: null });
            return response.data;
        } catch (error) {
            this.setState({ quote: null, quoteLoading: false, quoteError: this.props.t('unexpected error') });
            return null;
        }
    }

    applyPromoCode = async () => {
        const { promoCode } = this.state;
        const planId = this.props.match?.params?.planId;

        if (!promoCode.trim()) {
            this.setState((prevState) => ({
                selectedPlan: {
                    ...prevState.selectedPlan,
                    newPrice: null,
                },
                promoStatus: null
            }));
            // this.setState({ promoStatus: { type: 'error', message: 'Promo kod daxil edin' } });
            return;
        }

        if (!planId) {
            this.setState({ promoStatus: { type: 'error', message: 'Paket məlumatı düzgün deyil' } });
            return;
        }

        this.setState({ promoLoading: true });

        try {
            const response = await esimApi.validatePromo({
                code: promoCode.trim(),
                planId
            });

            const statusCode = Number(response?.status?.statusCode);

            if (statusCode !== 1) {
                this.setState((prevState) => ({
                    promoLoading: false,
                    promoStatus: { type: 'error', message: this.props.t(statusCode || 'unexpected error') },
                    selectedPlan: {
                        ...prevState.selectedPlan,
                        newPrice: null
                    }
                }));
                return;
            }

            const promoData = response?.data;
            const isPromoValid = promoData?.valid === true;
            const customerPayCents = Number(promoData?.customerPayCents);

            this.setState((prevState) => ({
                promoLoading: false,
                // ...(isPromoValid && Number.isFinite(customerPayCents) && customerPayCents > 0
                //     ? {
                selectedPlan: {
                    ...prevState.selectedPlan,
                    newPrice: this.formatPriceFromCents(customerPayCents)
                },
                // }                         
                // : {}),
                promoStatus: {
                    type: isPromoValid ? 'success' : 'error',
                    message: promoData?.reason || (promoData?.discountCents ? `Endirim tətbiq olundu: ${(promoData.discountCents / 100).toFixed(2)} AZN` : 'Promo kod qəbul edildi')
                }
            }));
            await this.calculateQuote(promoCode);
        } catch (error) {
            this.setState({ promoLoading: false, promoStatus: { type: 'error', message: 'Promo kod təsdiqlənmədi' } });
        }
    }

    submitOrder = async () => {
        const { orderEmail, orderPaymentMethod, promoCode } = this.state;
        const planId = this.props.match?.params?.planId;
        const quote = this.state.quote;
        const expectedPriceCents = Number(quote?.customerPayCents);

        if (!planId || !Number.isFinite(expectedPriceCents) || expectedPriceCents <= 0) {
            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t('Paket məlumatı düzgün deyil'));
            return;
        }

        this.setState({ isSubmitting: true });

        try {
            const requestBody = {
                planId,
                // expectedPriceCents,
                paymentSource: 'CARD',
                cardId: Number(this.state.cards[this.state.selectedValue]?.cardId),
                ...(this.state.promoStatus?.type === 'success' && this.state.promoCode?.trim() ? { promoCode: this.state.promoCode.trim() } : {}),
                ...(orderEmail?.trim() ? { customerEmail: orderEmail.trim() } : {}),
                ...(orderPaymentMethod ? {} : {}),
                ...(this.props.match?.params?.topUpEsimId ? { topUpEsimId: this.props.match.params.topUpEsimId } : {})
            };

            const response = await esimApi.createOrder(requestBody);
            // const orderData = response;
            const statusCode = Number(response?.status?.statusCode);

            if (statusCode !== 1) {
                this.setState({ isSubmitting: false, showSuccessModal: false, orderRef: null });
                this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(statusCode || 'unexpected error'));
                return;
            }

            this.setState({
                isSubmitting: false,
                showSuccessModal: true,
                esimId: response?.data?.esimId,
                // orderRef: orderData?.orderRef || orderData?.order?.orderRef || null
            });
        } catch (error) {
            this.setState({ isSubmitting: false, showSuccessModal: false, orderRef: null });
            this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t('unexpected error'));
        }
    }

    closeSuccessModal = () => {
        this.setState({ showSuccessModal: false });
    }

    openSetupPage = () => {
        const { selectedCountry, selectedPlan, esimId } = this.state;

        this.setState({ showSuccessModal: false }, () => {
            this.props.history.push({
                pathname: `/dashboard/services/e-sim/setup/${encodeURIComponent(selectedCountry.name)}/${esimId}`,
                state: {
                    selectedCountry,
                    selectedPlan
                }
            });
        });
    }

    render() {
        const { selectedCountry, selectedPlan, orderEmail, dropdownVisibility, promoCode, selectedValue, showSuccessModal, cards, step, quote, quoteLoading, quoteError } = this.state;
        const { t } = this.props;
        const orderAmount = quote?.customerPayCents !== undefined
            ? (Number(quote.customerPayCents) / 100).toFixed(2)
            : String(selectedPlan.newPrice ?? selectedPlan.price ?? "").replace('$', '').replace('AZN', '').replace('USD', '').trim();
        const orderCurrency = String(quote?.currency || selectedPlan.currency || 'AZN').toUpperCase();
        const commissionAmount = quote
            ? this.formatQuoteAmount(quote.commissionAmount, quote.commissionCurrency || orderCurrency)
            : '';
        const periodDays = String(selectedPlan.period || '').split(' ')[0] || '—';

        return (
            <>
                <ESIMOrderSuccessModal
                    open={showSuccessModal}
                    onClose={this.closeSuccessModal}
                    onLater={this.closeSuccessModal}
                    onInstallNow={this.openSetupPage}
                    countryName={selectedCountry.name}
                    countryFlag={selectedCountry.flag}
                    planVolume={selectedPlan.volume}
                />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIM')}</h2>
                    </div>
                </div>
                <div className="dashboard-account-body">
                    <div className="dashboard-payment-container-data-section m-3"                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         >
                        <div className="dashboard-esim-order">
                            <div className="dashboard-esim-order-header">
                                <h3 className="dashboard-esim-order-title">{t('Sifariş detalları')}</h3>
                            </div>

                            <div className="dashboard-esim-order-country">
                                <span>{selectedCountry.flag}</span>
                                <h4>{selectedCountry.name}</h4>
                            </div>

                            <div className="dashboard-esim-order-summary">
                                <div>
                                    <p>{t('Ödəniş')}</p>
                                    <p>{t('Gün')}</p>
                                    <p>{t('Paket')}</p>
                                    <p>{t('Qiymət')}</p>
                                    <p>{t('Commission')}</p>
                                </div>
                                <div>
                                    <p>eSIM</p>
                                    <p>{periodDays}</p>
                                    <p>{selectedPlan.volume}</p>
                                    <p>{orderAmount} {orderCurrency}</p>
                                    <p>{quoteLoading ? t('Yoxlanır...') : commissionAmount || '—'}</p>
                                </div>
                            </div>
                            {quoteError ? <p className="dashboard-esim-order-quote-error">{quoteError}</p> : null}

                            <div className="dashboard-esim-order-field">
                                <label htmlFor="esim-order-email">{t('e-mail')}</label>
                                <input
                                    id="esim-order-email"
                                    type="email"
                                    value={orderEmail}
                                    onChange={(event) => this.updateField('orderEmail', event.target.value)}
                                    placeholder={t('Daxil edin')}
                                />
                            </div>

                            {/* <div className="dashboard-esim-order-field">
                                <label htmlFor="esim-order-payment-method">Ödəniş üsulu</label>
                                <select
                                    id="esim-order-payment-method"
                                    value={orderPaymentMethod}
                                    onChange={(event) => this.updateField('orderPaymentMethod', event.target.value)}
                                >
                                    <option value="">Seçim edin</option>
                                    {paymentMethods.map((method) => (
                                        <option value={method} key={method}>{method}</option>
                                    ))}
                                </select>
                            </div> */}
                            <div className="dashboard-payment-container-data-section-content-container-form-input-group">
                                <label className="dashboard-payment-container-data-section-content-container-form-label">{t('Select funds')}</label>
                                <div className="dashboard-payment-container-data-section-content-container-form-select-box">
                                    <button className={`dashboard-payment-container-data-section-content-container-form-select-box-button ${step > 1 ? "dashboard-payment-container-data-section-content-container-form-select-box-button__disable" : "dashboard-payment-container-data-section-content-container-form-select-box-button"}`} onClick={this.changeDropdownVisibility}>
                                        <div className="dashboard-payment-container-data-section-content-container-form-select">
                                            {(cards && selectedValue < 0 && cards.length > 0 ? t('Select a payment method') : cards && selectedValue >= 0 && cards.length > 0 && (`${cards[selectedValue].balance} ${cards[selectedValue].currency} / ${cards[selectedValue].homePhone}${cards[selectedValue].cardName ? `, ${cards[selectedValue].cardName}` : ''}, ${cards[selectedValue].maskedPan}`))}
                                        </div>
                                        <div className="dashboard-payment-container-data-section-content-container-form-icon">
                                            <svg className="dashboard-payment-container-data-section-content-container-form-icon-img" width="13" height="8" viewBox="0 0 13 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path id="chevron-down copy 2" d="M12.4336 1.34375L11.9141 0.796875C11.7773 0.660156 11.5586 0.660156 11.4492 0.796875L6.5 5.74609L1.52344 0.796875C1.41406 0.660156 1.19531 0.660156 1.05859 0.796875L0.539063 1.34375C0.402344 1.45312 0.402344 1.67188 0.539063 1.80859L6.25391 7.52344C6.39063 7.66016 6.58203 7.66016 6.71875 7.52344L12.4336 1.80859C12.5703 1.67187 12.5703 1.45312 12.4336 1.34375Z" fill="#849097" />
                                            </svg>
                                        </div>
                                    </button>
                                    <ul className={(dropdownVisibility === false) ? "dashboard-payment-container-data-section-content-container-form-select-box-list dashboard-payment-container-data-section-content-container-form-select-box-list__hidden" : "dashboard-payment-container-data-section-content-container-form-select-box-list"}>
                                        {cards && cards.length > 0 &&
                                            cards.map((card, index) => {
                                                return (
                                                    <li key={index} className="dashboard-payment-container-data-section-content-container-form-select-box-list-item">
                                                        <button onClick={e => this.onSelect(e, index)} disabled={!Boolean(card.cardStatus)} className={!Boolean(card.cardStatus) ? "dashboard-payment-container-data-section-content-container-form-select-box-list-item-button__disable" : "dashboard-payment-container-data-section-content-container-form-select-box-list-item-button"}>
                                                            {`${card.balance} ${card.currency} / ${card.homePhone}${card.cardName ? `, ${card.cardName}` : ''}, ${card.maskedPan}`}
                                                        </button>
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                </div>
                            </div>

                            <div className="dashboard-esim-order-field">
                                <label htmlFor="esim-order-promo">{t('Promo kod')}</label>
                                <div className="dashboard-esim-order-promo">
                                    <input
                                        id="esim-order-promo"
                                        type="text"
                                        className={`dashboard-esim-order-promo-input ${this.state.promoStatus?.type === 'error' && `border-danger`}`}
                                        value={promoCode}
                                        onChange={this.handlePromoCodeChange}
                                        placeholder={t('Daxil edin')}
                                    />
                                    <button type="button" onClick={this.applyPromoCode} disabled={this.state.promoLoading}>
                                        {this.state.promoLoading ? t('Yoxlanır...') : t('Tətbiq et')}
                                    </button>
                                </div>
                                {this.state.promoStatus ? <p className={`dashboard-esim-order-promo-status dashboard-esim-order-promo-status__${this.state.promoStatus.type}`}>{this.state.promoStatus.message}</p> : null}
                            </div>

                            <div className="dashboard-esim-order-total">
                                <span>{t('Ödəniləcək məbləğ')}:</span>
                                <strong>{orderAmount} {orderCurrency}</strong>
                            </div>

                            <button className="dashboard-esim-order-pay-button" type="button" onClick={this.submitOrder} disabled={this.state.isSubmitting || quoteLoading || !quote}>
                                {this.state.isSubmitting ? t('Göndərilir...') : t('Ödəniş et')}
                            </button>
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Payment confirmation')}</h3>
                        </div>

                        <div className="dashboard-payment-container-confirmation-section-content py-5 px-2">
                            {
                                step >= 2 ?
                                    <>
                                        <h3 className="dashboard-payment-container-confirmation-section-amount">
                                            <span className="dashboard-payment-container-confirmation-section-amount-currency dashboard-payment-container-confirmation-section-amount-currency__azn">{currencyFilter(orderCurrency)}</span>
                                            <span className="dashboard-payment-container-confirmation-section-amount-whole">{this.amountSplit(orderAmount).part1}</span>
                                            <span className="dashboard-payment-container-confirmation-section-amount-fractional">{this.amountSplit(orderAmount).part2}</span>
                                        </h3>
                                        {/* <ul className="dashboard-payment-container-confirmation-section-list">
                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('Total amount owed')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">
                                                    <span style={{ fontSize: '14px' }}>{credit?.loanAmount}</span>
                                                    <span className="dashboard-payment-container-confirmation-section-amount-currency dashboard-payment-container-confirmation-section-amount-currency__azn__new" style={{ fontSize: '14px' }}>{currencyFilter('azn')}</span>
                                                </p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('credit')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">{credit.loanType}</p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('Commission')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">{(penaltyAmount ? penaltyAmount : '0.00') + ' ' + credit.currency}</p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('Total amount')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">{totalAmount || parseFloat(amount) + parseFloat(penaltyAmount || '0.00')} {credit.currency}</p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('credit')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">{credit.loanType}</p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('fund')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">
                                                    {selectedPaymentSource == 1 && fromAnotherCard ? t('Another bank card') : (cards && selectedValue >= 0 && cards.length > 0 && cards[selectedValue].organizedCardNumber)}
                                                    {selectedPaymentSource == 2 && selectedAccount?.split(" / ")[0]}
                                                </p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-title">{t('Repayment method')}</p>
                                                <p className="dashboard-payment-container-data-section-content-container-form-group-data">{selectedType?.name}</p>
                                            </li>

                                            <li className="dashboard-payment-container-confirmation-section-list-item">
                                                                                <div className="dashboard-payment-container-data-section-content-container-form-footer">
                                                                                    {
                                                                                        (selectedPaymentSource == 1 ? cards && selectedValue >= 0 && cards?.length > 0 && cards[0]?.organizedCardNumber : selectedAccount) ?
                                                                                            <button onClick={e => { isPenaltyAmount && penaltyAmount > 0 ? this.setState({ openYesNo: true }) : (cards[selectedValue]?.cardType === cardTypes.CARD_STORAGE ? this.payWithOtherBankCards(e) : this.pay_process(e)) }} className={"dashboard-payment-container-data-section-content-container-form-footer-button dashboard-payment-container-data-section-content-container-form-footer-button__blue dashboard-payment-container-data-section-content-container-form-footer-button__left"}>{t('make a payment')}</button>
                                                                                            :
                                                                                            null
                                                                                    }
                                                                                    <button onClick={(e) => this.setState({ step: 1 })} className="dashboard-payment-container-data-section-content-container-form-footer-button dashboard-payment-container-data-section-content-container-form-footer-button__gray dashboard-payment-container-data-section-content-container-form-footer-button__right">{t('refusal')}</button>
                                                                                </div>
                                                                            </li>
                                        </ul> */}

                                    </>
                                    :
                                    <div className="dashboard-payment-container-confirmation-section-empty">
                                        <img src={lastOperationIcon} className="dashboard-payment-container-confirmation-section-content-image" alt="_image" />
                                        <p className="dashboard-payment-container-confirmation-section-content-description">{t('To complete the payment, please enter the payment settings and continue.')}</p>
                                    </div>
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default translate('translation')(ESIMOrder);